export default __webpack_public_path__ + "static/media/funds__reporting.7489075b.png";